import { ReactNode } from "react";

import { PencilFill } from "@hl/base-components/lib/assets/icons.generated";
import { UTILITY_COLOR } from "@hl/base-components/lib/theme/colors";
import { ActionIcon, Group, Box, Center } from "@mantine/core";

import { ReactComponent as CloseButton } from "assets/icons/trash-fill.svg";

const ConditionBox = ({
  image,
  description,
  onRemoveCondition,
  onEditCondition,
  rounded,
}: {
  image: ReactNode;
  description: ReactNode;
  onRemoveCondition: () => void;
  onEditCondition?: () => void;
  rounded?: boolean;
}) => {
  return (
    <Group spacing={12} py={12}>
      <Center
        w={68}
        h={68}
        bg={UTILITY_COLOR.TABLE_ROW_BACKGROUND}
        sx={(theme) => ({
          border: `1px solid ${theme.colors.divider[0]}`,
          overflow: "hidden",
          borderRadius: rounded ? theme.radius.sm : "100%",
        })}
      >
        {image}
      </Center>
      <Box sx={{ flexGrow: 1, flexBasis: 0 }} pr={4}>
        {description}
      </Box>
      <Group spacing={4}>
        {onEditCondition && (
          <ActionIcon
            size={32}
            onClick={onEditCondition}
            aria-label="Edit Condition"
          >
            <PencilFill height={16} />
          </ActionIcon>
        )}
        <ActionIcon
          size={32}
          onClick={onRemoveCondition}
          aria-label="Remove Condition"
        >
          <CloseButton height={16} />
        </ActionIcon>
      </Group>
    </Group>
  );
};

export default ConditionBox;
